import { TranslationDto } from "./translation.dto"

export class HomeSectionTitleParamKeyDto {
  key: string
}

export class HomeSectionTitleUpdateDto {
  title: TranslationDto
}